import ProductDescription from './ProductDescription'

const BarleyProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '006',
  IsBroadband: true,
  GrainSize: '16 ounces only',
  BarleyVerification: '',
  Organic: false,
}

export default BarleyProduct
